import { Translatable } from "@icc/shared/helpers";
import { RollerGuideOverlaySnapPlate } from "./guide-overlay-snap-plate";

export class RollerGuideOverlay {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    width: number;
    img: null | string;
    order?: number;
    default?: boolean;
    length?: number | null;
    colorGroupSetId: number | null;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;

    guideIds?: number[];

    /** Płytka zatrzaskowa powiązana z nakładką */
    snapPlate?: RollerGuideOverlaySnapPlate | null;
}

export interface IccRollerGuideOverlay {
    id: number;
    extId: string;
    indexNo: string;
    name: string;
    width: number;
    img: null | string;
    order?: number;
    shutterTypes: number[];
    colorGroupSetId: number;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
    guideIds?: number[];
}
